import { Alert, AlertDescription } from '@/components/ui/alert';
import { AlertTriangle, Calendar } from 'lucide-react';
import { QuoteData } from '@/services/quoteService';

interface ExpiredQuoteBannerProps {
  quote: QuoteData;
}

export default function ExpiredQuoteBanner({ quote }: ExpiredQuoteBannerProps) {
  // Only show if the quote is actually expired
  if (quote.status !== 'expired') {
    return null;
  }

  // Format the expiration date
  const expirationDate = quote.expiresAt.toLocaleDateString('es-ES', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <div className="mb-4">
      <Alert variant="destructive" className="bg-red-50 border-red-200 text-red-700">
        <AlertTriangle className="h-4 w-4" />
        <AlertDescription className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
          <div className="flex items-center gap-2">
            <span>
              Esta cotización expiró el {expirationDate}. Los precios pueden haber cambiado.
            </span>
          </div>
        </AlertDescription>
      </Alert>
    </div>
  );
}